import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-files",
    templateUrl: "./files.component.html",
    styleUrls: ["./files.component.scss"],
})
export class FilesComponent implements OnInit {
    title: string;
    info: string;
    pdfSrc: string;
    fileExists: boolean | null = null;

    constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router) {
        this.route.queryParams.subscribe((params) => {
            this.info = params["name"];
            if (this.info.includes("and")) {
                this.info = this.info.replace("and", "&");
            }
        });
    }

    ngOnInit(): void {
        this.title = this.info.split("_")[0];
        this.pdfSrc = "/assets/files/" + this.info + ".pdf";
        this.checkFileExists();
    }

    checkFileExists() {
        this.http.head(this.pdfSrc, { observe: "response" }).subscribe({
            next: (response) => {
                if (response.status === 200) {
                    this.fileExists = true;
                }
            },
            error: (error: HttpErrorResponse) => {
                this.fileExists = false;
                this.router.navigate(["/404"]);
            },
        });
    }
}
